var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBandsintown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80043 16.2V12.6H20.9999V20.9994H3.00098V3.00049H6.60043V17.4H17.4004V16.2H7.80043ZM21.0005 3.00049H17.4005V11.4H21.0005V3.00049ZM7.80041 6.59994H11.4004V11.3999H7.80041V6.59994ZM12.6005 6.59994H16.2005V11.3999H12.6005V6.59994Z",
    fill: "#00D2C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandsintown);
export default __webpack_public_path__ + "static/media/bandsintown.dff17cda.svg";
export { ForwardRef as ReactComponent };